<template>
  <footer class="footer footer--6">
    <div class="container">
      <logo></logo>
      <div class="footer__wrap">
        <footer-nav></footer-nav>
        <contacts></contacts>
      </div>
      <div class="d-flex justify-content-between">
        <copyright></copyright>
        <paysistems></paysistems>
      </div>
    </div>
  </footer>
</template>

<script>
import Logo from "./parts/Logo.vue";
import Slogan from "./parts/Slogan.vue";
import FooterNav from "./parts/FooterNav.vue";
import Contacts from "./parts/Contacts.vue";
import Paysistems from "./parts/Paysistems.vue";
import Copyright from "./parts/Copyright.vue";

export default {
  components: {
    Logo,
    Slogan,
    FooterNav,
    Contacts,
    Paysistems,
    Copyright,
  },
};
</script>

<style lang="scss">
.footer--6 {
  &.footer {
    padding: 40px 0 20px;
    background-color: $dark_color;

    @media (min-width: $breakpoint_lg) {
      padding-bottom: 40px;
    }

    .footer__wrap {
      margin-bottom: 20px;
      padding: 20px 8px;
      border-radius: 12px;
      border: 1px solid $accent_bg_dark;

      @media (min-width: $breakpoint_xl) {
        margin-bottom: 12px;
        padding: 24px;
        border-radius: 24px;
      }
    }
    .footer__logo {
      max-width: 188px;
      margin: 0 auto 40px auto;
    }
    .footer__menu {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 24px;
      @include font-height(12, 16, 600);

      @media (min-width: $breakpoint_lg) {
        flex-direction: row;
        justify-content: center;
        gap: 40px;
        @include font-height(16, 20, 600);
      }
    }
    .footer__menu-item a {
      transition: all $transition;

      &:hover,
      &:focus-visible {
        color: $accent_color;
      }
    }
    .footer__contacts {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 20px;
      text-align: center;
      @include font-height(12, 16);
      margin: 40px 0 0;

      @media (min-width: $breakpoint_lg) {
        flex-direction: row;
        justify-content: center;
        gap: 40px;
        @include font-height(14, 18);
      }
    }
    .footer__paysistems {
      display: flex;
      gap: 12px;
    }
    .footer__copyright {
      @media (max-width: $breakpoint-lg) {
        @include font-height(10, 13);
      }
    }
  }
}
</style>
